export const COLOR_BLACK = '#1A1A1A';
export const COLOR_BLACK_STANDARD = '#000000';
export const COLOR_BLACK_NIGHT = '#0D2121';
export const COLOR_LIGHT_BLUE = '#6DD6DA';
export const COLOR_DARK_BLUE = '#445972';
export const COLOR_DARK_BLUE_80 = '#445972CC';
export const COLOR_BROWN = '#958E8E';
export const COLOR_DARK_BROWN = '#676161';
export const COLOR_GREY_LIGHT = '#DDDDDD';
export const COLOR_GREY_CAT = '#76838B';
export const COLOR_GREY_DARK = '#393939';
export const COLOR_GREY_SHADOW = '#525A5F'
export const COLOR_GRAY_COSTA_MESA = '#F9F9F9';
export const COLOR_GREY_RAINY_DAY = '#3B4956';
export const COLOR_OAT_MILK = '#F6F3F1';
export const COLOR_SALMON = '#FF6259';
export const COLOR_STEAK_SAUCE = '#A1A1A1';
export const COLOR_WHITE = '#FFFFFF';
export const COLOR_YELLOW = '#FFE86F';
export const COLOR_GIGGITY = '#696969';
export const COLOR_EGG_SHELL = '#FFF7E2';
export const COLOR_PRIMARY_RED = '#D51D4C';
export const COLOR_TREND_UP_GREEN = '#1E923E';
